<template>
  <div class="sign-in-page" v-if="showWindow">
    <!-- 页面顶部 -->


    <!-- 人脸识别区域 -->
    <div class="face-recognition-container">
      <div class="face-frame">
        <img src="../assets/index/ipc.png" alt="用户头像" class="avatar" />
        <div class="capture-circle">
          <div class="inner-circle"></div>
          <div class="outer-circle"></div>
        </div>
      </div>
      <p class="instruction">当前业务需要人脸识别认证</p>
    </div>

    <!-- 用户信息 -->
    <div class="user-info">
      <div class="info-item">
        <span class="label">身份证号</span>
        <input v-model="idCardNumber" type="text" placeholder="请输入身份证号" class="input-field" />
      </div>

    </div>
    <div class="agreement-item">
      <input type="checkbox" v-model="agreeProtocol" id="agreeProtocol" class="agreement-checkbox" />
      <label for="agreeProtocol" class="agreement-label">
        已阅读并同意<a href="javascript:;" class="protocol-link" @click="jumpToProtocol">《人脸认证服务协议》</a>
      </label>
    </div>
    <!-- 操作按钮 -->
    <button :class="!agreeProtocol ? 'start-button disable' : 'start-button'"
      @click="startFaceRecognition">开始人脸识别认证</button>
    <div class="massageBox" v-if="msgFlag">
      <div class="massageBox-item">
        <div class="massageBox-item-content">{{ msgShow }}</div>
        <div class="massageBox-item-bts" @click="msgFlag = false">确定</div>
      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable no-undef */
const { redirectSuccessPage, redirectOverPage } = require('../utils/authRoute.js')
//import VConsole from 'vconsole';
import { firstApi } from '../http/api';
export default {
  name: 'SignInPage',
  data() {
    return {
      msgFlag: false,
      msgShow: '',
      showWindow: true,
      idCardNumber: '',// 默认值
      certifyId: '',
      agreeProtocol: false, // 新增：协议勾选状态
      // 新增：定位相关数据
      locationInfo: '', // 显示定位信息
      locationData: { // 存储定位数据
        latitude: '',
        longitude: '',
        address: ''
      },
      // 腾讯地图Key，替换为你自己申请的Key
      tencentKey: '3JUBZ-NED6C-3UP2J-A7BS7-YQYZO-CFBRZ',
      pageFlag: '', // 后端回跳拼接的分流标记：'newPage2' 走新页面链路
    };
  },
  created() {
    let url = new URL(window.location.href);
    const pageFlag = url.searchParams.get('pageFlag')
    this.pageFlag = pageFlag || ''
    // 分支一（新）：zim（支付宝核身）回跳，response 为 JSON 串
    // 注意：本分支不调 getToken() —— verifyToken 的自动跳转走老链路（无 pageFlag），
    // 会和上面的分流跳转形成双重跳转竞争，因此处理完 response 直接 return
    const response = url.searchParams.get('response')
    if (response) {
      try {
        this.handleZimResponse(JSON.parse(response))
      } catch (e) {
        console.error('response 参数解析失败:', e)
        this.showWindow = true
        this.msgShow = '回跳数据异常，请重新认证'
        this.msgFlag = true
      }
      return
    }
    // 分支二（原有）：chinadatapay 回调参数 token / code
    let token = url.searchParams.get('token')
    let code = url.searchParams.get('code')
    console.log('token:', token, 'code:', code);
    if (token && code) {
      this.showWindow = false;
      this.certifyId = token; // certifyId 即 URL 中的 token
      this.handleError(code);
    } else {
      this.showWindow = true;
    }
    console.log('certifyId:', this.certifyId);
    this.getToken();
  },
  mounted() {
    // try {
    //     const vConsole = new VConsole();
    //     console.log('vconsole 初始化成功', vConsole);
    //     // 强制显示 vconsole 面板
    //     setTimeout(() => {
    //       if (vConsole && typeof vConsole.show === 'function') {
    //         vConsole.show();
    //         console.log('vconsole 已显示');
    //       }
    //     }, 1000);

    //   } catch (error) {
    //     console.error('vconsole 初始化失败:', error);
    //   }

  },
  methods: {
    // 处理 zim（支付宝核身）回跳 response
    handleZimResponse(resp) {
      const certifyId = resp.extInfo && resp.extInfo.certifyId
      if (resp.code == 1000 && certifyId) {
        this.showWindow = false // 防止跳转瞬间登录表单闪现
        redirectSuccessPage(certifyId, this.pageFlag)
      } else {
        this.showWindow = true
        if (resp.subCode === 'Z5055') return // 用户退出，不提示
        this.msgShow = this.zimErrorMsg(resp)
        this.msgFlag = true
      }
    },
    // zim 错误码 → 文案（对照 kong.vue 原有对照表）
    zimErrorMsg(resp) {
      const subMap = {
        Z5051: '上传刷脸图片失败',
        Z5052: '数据错误或程序异常',
        Z5053: '网络错误',
        Z5054: '摄像头无权限或无法获取摄像头数据',
        Z5056: '重试次数过多',
        Z5058: '视频格式不满足要求',
        Z5059: '视频中无有效人脸',
        Z5128: '刷脸验证失败，认证未通过'
      }
      const codeMap = {
        1001: '系统错误，请重试',
        2002: '网络错误，请重试',
        2003: '客户端设备时间错误'
      }
      if (resp.code == 1003 || resp.code == 2006) {
        return subMap[resp.subCode] || ('认证失败：' + (resp.subCode || resp.code))
      }
      return codeMap[resp.code] || ('认证失败，错误码：' + resp.code)
    },

    jumpToProtocol() {
      this.$router.push({
        path: '/makeSureText',
      });
    },
    //获取token 判断有无过期 过期 则清理 没过期就直接跳转到认证成功
    getToken() {
      const token = window.localStorage.getItem('token');
      if (token) {
        firstApi.verifyToken().then((e) => {
          console.log(e, '认证结果');
          if (e.code == 1) {
            // this.$router.push({
            //   path: '/success',
            //   query: {
            //     certifyId: e.data.certifyId,
            //     code: '1000'
            //   }
            // });
            const token = localStorage.getItem('token');
            // 可选：通知小程序关闭当前 web-view 页面 /pages/loding/loding
            wx.miniProgram.postMessage({
              data: { token },
            });
            // 已认证：按计划配置的 pageFlag 动态跳转（未配置走老 success）
            redirectSuccessPage(e.data.certifyId, e.data.pageFlag);
          } else if (e.code == 2003) {
            const token = localStorage.getItem('token');
            console.log('认证结果2003', e.data.certifyId);
            wx.miniProgram.postMessage({
              data: { token },
            });
            // 已签到：跳对应回显页（未配置走老 overRight）
            redirectOverPage(e.data.certifyId, e.data.pageFlag);
          }

        });
      }
    },
    handleError(code) {
      // 新第三方(chinadatapay):code=10000 表示认证成功,其余为失败
      if (code == 10000) {
        // 认证成功后,先调用后端下载人脸图片接口,无论成功失败都跳转小程序
        firstApi.faceVerifyCallBack({ certifyId: this.certifyId })
          .then((res) => {
            console.log('faceVerifyCallBack 成功:', res);
            this.jumpToSuccess();
          })
          .catch((err) => {
            console.error('faceVerifyCallBack 失败:', err);
            this.jumpToSuccess();
          });
      } else {
        this.showWindow = true;
        this.msgFlag = true;
        this.msgShow = '认证失败，请重试。';
      }
    },
    // 跳转小程序成功页（按 pageFlag 分流）
    jumpToSuccess() {
      redirectSuccessPage(this.certifyId, this.pageFlag)
    },
    async startFaceRecognition() {
      if (!this.agreeProtocol) {

        return;
      }
      if (!this.idCardNumber.trim()) {
        //   alert('请输入身份证号');
        this.msgShow = '请输入身份证号'
        this.msgFlag = true;
        return;
      }

      try {

        firstApi.initFaceVerify({
          idCardNumber: this.idCardNumber
        })
          // fetch('https://ysj.hnykzd.com/vpp/api/sign/initFaceVerify', {
          //   method: 'POST',
          //   headers: {
          //     'Content-Type': 'application/json'
          //   },
          //   body: JSON.stringify({
          //     metaInfoVo: MetaInfo,
          //     user: {
          //       idCardNumber: this.idCardNumber,
          //       idCardName: this.userName
          //     }
          //   })

          // })
          //   .then(response => response.json())
          .then(data => {
            console.log('data:', data)
            if (data.code == 1) {
              window.localStorage.setItem('token', data.data.token);
              wx.miniProgram.postMessage({
                data: { token: data.data.token },
              });

              if (data.data.address) {
                wx.miniProgram.navigateTo({
                  url: `/pages/position/position?token=${data.data.token}`
                });
              } else {
                this.geturl();
              }

            } else if (data.code == 2002) {
              const token = data.data.token;
              window.localStorage.setItem('token', data.data.token);
              // 可选：通知小程序关闭当前 web-view 页面 /pages/loding/loding
              wx.miniProgram.postMessage({
                data: { token },
              });
              // 已认证：按计划配置的 pageFlag 动态跳转（未配置走老 success）
              redirectSuccessPage(data.data.certifyId, data.data.pageFlag);
            } else if (data.code == 2003) {
              const token = data.data.token;
              window.localStorage.setItem('token', data.data.token);
              // 可选：通知小程序关闭当前 web-view 页面 /pages/loding/loding
              wx.miniProgram.postMessage({
                data: { token },
              });
              // 已签到：跳对应回显页（未配置走老 overRight）
              redirectOverPage(data.data.certifyId, data.data.pageFlag);
            } else {
              // alert(data.msg)
              this.msgShow = data.msg
              this.msgFlag = true;
            }
            // 获取CertifyUrl后跳转至认证页面

          })
      } catch (error) {
        console.error('认证出错:', error);
        //  alert(error);
        this.msgShow = error
        this.msgFlag = true;
      }
    },
    geturl() {
      const MetaInfo = window.getMetaInfo();
      MetaInfo.TerminalType = "H5"
      firstApi.initFaceVerifyBack({ metaInfovo: MetaInfo }).then((e) => {
        console.log(e)
        if (e.code == 1) {
          window.location.href = e.data.certifyUrl;
        } else {
          this.msgShow = e.msg
          this.msgFlag = true;
        }
        // console.log(e)
      });
    }
  }
};
</script>

<style scoped>
div {
  box-sizing: border-box;
}

.sign-in-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  height: 100vh;
  overflow: hidden;

}

.massageBox {
  width: 100%;
  height: 100vh;
  padding-top: 20vh;
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  z-index: 999;
  top: 0;
}

.massageBox-item {

  width: 90%;

  margin: 0 auto;
  background-color: #fff;
  border-radius: 10px;

}

.massageBox-item-content {


  text-align: center;
  border-bottom: 1px solid #eee;
  padding: 5vh 10px;
  font-size: 16px;
  color: #333;

}

.massageBox-item-bts {
  text-align: center;
  padding-top: 2vh;
  padding-bottom: 2vh;
  font-size: 16px;
  color: #333;
  font-weight: 550;

}

.page-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.action-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.face-recognition-container {
  margin-top: 20px;
  text-align: center;
}

.face-frame {
  width: 200px;
  height: 200px;
  border: 2px dashed #007bff;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  background-color: #eee;
}

.capture-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 160px;
  height: 160px;
  border: 2px solid #007bff;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.inner-circle {
  width: 120px;
  height: 120px;
  border: 2px solid #007bff;
  border-radius: 50%;
  margin: 20px auto;
  animation: rotate 2s linear infinite;
}

.outer-circle {
  width: 180px;
  height: 180px;
  border: 1px dashed #007bff;
  border-radius: 50%;
  margin: 10px auto;
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
  }

  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.instruction {
  margin-top: 20px;
  font-size: 16px;
  color: #333;
}

.user-info {
  width: 100%;
  margin: 30px 0;
  padding: 0 20px;
  background-color: #fff;
  /* border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
}

.info-item {
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.label {
  font-weight: bold;
  color: #333;
  width: 80px;
  /* 固定宽度，保证对齐 */
  text-align: left;
}

.value {
  color: #666;
}

.start-button {
  width: 100%;
  padding: 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
}

.disable {

  opacity: 0.5;
  pointer-events: none;

}

.input-field {
  flex: 1;
  padding: 8px 0;
  /* 垂直内边距 */
  border: none;
  /* 移除边框 */
  background-color: transparent;
  /* 透明背景 */
  outline: none;
  /* 移除聚焦边框 */
  font-size: 14px;
  color: #333;
  text-align: left;
  /* 文字右对齐 */
  margin-left: 10px;
  /* 与标签之间留空隙 */
}

.input-field:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}

/* 新增协议勾选框样式 */
.agreement-item {
  margin-top: 20px;
  display: flex;
  align-items: flex-start;
  padding: 0 5px;
}

.agreement-checkbox {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  margin-top: 2px;
  cursor: pointer;
}

.agreement-label {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  cursor: pointer;
}

.protocol-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

.protocol-link:hover {
  text-decoration: underline;
}
</style>